import { GlobalStyles } from "@contentful/f36-components";
import type { AppProps } from "next/app";
import Head from "next/head";
import "../styles/index.css";

const MyApp = ({ Component, pageProps }: AppProps) => {
	return (
		<>
			<Head>
				<title>Evernest Contentful Extensions</title>
			</Head>
			<GlobalStyles />
			<Component {...pageProps} />
		</>
	);
};

export default MyApp;
